import React from "react";
import { useNavigate } from "react-router-dom";

const AdminDashboard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#f5f5f5",
      }}
    >
      <h1 style={{ color: "#f97316", marginBottom: "40px" }}>
        Admin Dashboard
      </h1>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 200px)",
          gap: "20px",
        }}
      >
        <button
          onClick={() => navigate("/roles")}
          style={{
            backgroundColor: "#f97316",
            color: "white",
            border: "none",
            padding: "16px",
            borderRadius: "12px",
            cursor: "pointer",
            fontSize: "16px",
            fontWeight: "bold",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          }}
        >
          Role Management
        </button>

        <button
          onClick={() => navigate("/usermanagement")}
          style={{
            backgroundColor: "#f97316",
            color: "white",
            border: "none",
            padding: "16px",
            borderRadius: "12px",
            cursor: "pointer",
            fontSize: "16px",
            fontWeight: "bold",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          }}
        >
          User Management
        </button>

        <button
          onClick={() => navigate("/responsiblepersons")}
          style={{
            backgroundColor: "#f97316",
            color: "white",
            border: "none",
            padding: "16px",
            borderRadius: "12px",
            cursor: "pointer",
            fontSize: "16px",
            fontWeight: "bold",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          }}
        >
         Responsible Persons Managment
        </button>

        <button
          onClick={() => navigate("/reports")}
          style={{
            backgroundColor: "#f97316",
            color: "white",
            border: "none",
            padding: "16px",
            borderRadius: "12px",
            cursor: "pointer",
            fontSize: "16px",
            fontWeight: "bold",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          }}
        >
          Reports
        </button>
      </div>
    </div>
  );
};

export default AdminDashboard;
